import React, { useState } from 'react'
// @ts-ignore no types
import { Text, hooks } from '@adc/ui-adc'

// Constants for text limits
const MAX_VISIBLE_CHARACTERS = 140
const COLLAPSE_SUFFIX_LENGTH = 3
const MAX_COLLAPSE_SIZE = MAX_VISIBLE_CHARACTERS - COLLAPSE_SUFFIX_LENGTH
const EXPAND_LABEL_EXTRA_SPACE = 10

interface SpecialNotesProps {
  notes: string
}

const SpecialNotes = ({ notes }: SpecialNotesProps) => {
  const [collapsed, setCollapsed] = useState(true)
  const toggleCollapse = () => setCollapsed(!collapsed)
  const isMobile = hooks.useIsMobileHook()

  if (!notes) return null

  const titleSize = isMobile ? 'big' : 'huge'
  const textSizeLimit = MAX_COLLAPSE_SIZE + EXPAND_LABEL_EXTRA_SPACE

  return (
    <div>
      <Text
        as='p'
        size={titleSize}
        weight='medium'
        data-elm-id='mls_comment_label'
      >
        Special Notes
      </Text>

      <Text as='p' color='gray' data-elm-id='mls_comment_value'>
        {notes.length < textSizeLimit ? (
          notes
        ) : (
          <span>
            {collapsed ? `${notes.substring(0, MAX_COLLAPSE_SIZE)}...` : notes}{' '}
            <a onClick={toggleCollapse}>
              {collapsed ? 'More \u00BB' : '\u00AB Less'}
            </a>
          </span>
        )}
      </Text>
    </div>
  )
}

export default SpecialNotes
